import canvas from "./canvas.mjs";
import context2d from "./context2d.mjs";
import download from "./download.mjs";
import element from "./element.mjs";
import input from "./input.mjs";
import range from "./range.mjs";
import select from "./select.mjs";
import svg from "./svg.mjs";
import text from "./text.mjs";
import uid from "./uid.mjs";

export default {
  canvas: canvas,
  context2d: context2d,
  download: download,
  element: element,
  input: input,
  range: range,
  select: select,
  svg: svg,
  text: text,
  uid: uid
};
